function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
import Carousel from '@mozaic-ds/freemarker/js/modules/_carousel.js';
var LinkedContent = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {lm.Composant} component
   */
  function LinkedContent(component) {
    var _this = this;
    _classCallCheck(this, LinkedContent);
    _toConsumableArray(component.querySelectorAll('.o-article__linked-product-slider')).forEach(function (slider) {
      var carouselElement = document.getElementById(slider.id);
      new Carousel(carouselElement, {
        centerWhenNoButtons: true
      });
    });
    _toConsumableArray(component.querySelectorAll('.o-article__recommended-product-slider')).forEach(function (slider) {
      var carouselElement = document.getElementById(slider.id);
      new Carousel(carouselElement, {
        centerWhenNoButtons: true
      });
    });

    // Add directly the promiseId for all recommended products sections
    var promiseId = 1;
    _toConsumableArray(component.querySelectorAll('[id^="zone_recommended_products_"]')).forEach(function (zoneReco) {
      var zoneRecoElement = document.getElementById(zoneReco.id);
      _this.setDataPromisePosition(zoneRecoElement, promiseId);
      promiseId++;
    });

    // Add after 1sec the data_merch_arbo to have access to the tc_vars
    setTimeout(function () {
      var pageArbo = _this.getPageArbo();
      _toConsumableArray(component.querySelectorAll('[id^="zone_recommended_products_"]')).forEach(function (zoneReco) {
        var zoneRecoElement = document.getElementById(zoneReco.id);
        _this.setDataMerchArbo(zoneRecoElement, pageArbo);
      });
    }, 1000); // Add a delay to have access to the tc_vars
  }

  /** * Get the page arbo from the window.tc_vars object
   *
   * @returns {*[]}
   */
  return _createClass(LinkedContent, [{
    key: "getPageArbo",
    value: function getPageArbo() {
      return ['cdl_page_category1', 'cdl_page_category2', 'cdl_page_category3', 'cdl_page_category4'].filter(function (key) {
        return window.tc_vars[key] && window.tc_vars[key] !== '';
      }).map(function (key) {
        return window.tc_vars[key];
      });
    }

    /**
     * Set the data-merch-arbo attribute on the section element
     * @param {HTMLElement} section - The section element to set the attribute on
     */
  }, {
    key: "setDataMerchArbo",
    value: function setDataMerchArbo(section, pageArbo) {
      var sectionHasAttribute = section.hasAttribute('data-merch-arbo');
      if (sectionHasAttribute) {
        section.setAttribute('data-merch-arbo', pageArbo.join('/'));
      } else {
        console.warn('Section does not have "data-merch-arbo" attribute');
      }
    }

    /**
     * Set the data-promise-position attribute on the section element
     * @param section
     * @param promisePosition
     */
  }, {
    key: "setDataPromisePosition",
    value: function setDataPromisePosition(section, promisePosition) {
      var sectionHasAttribute = section.hasAttribute('data-promise-position');
      if (sectionHasAttribute) {
        section.setAttribute('data-promise-position', promisePosition);
      } else {
        console.warn('Section does not have "data-promise-position" attribute');
      }
    }
  }]);
}();
export { LinkedContent as default };